var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMickyFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1556 11.4528C19.6343 10.823 19.271 12.7359 19.271 12.7825C19.0213 12.7589 18.7262 12.7825 18.3853 12.8756C18.3175 9.40015 15.7062 6.64809 12.4819 6.53132C13.231 5.69164 13.6627 4.64203 13.4807 3.52226C13.1857 1.5162 11.1421 0.13994 9.00787 0.583315C6.89603 0.956573 5.39723 2.86896 5.69283 4.89857C5.94252 6.39104 7.12332 7.51082 8.64451 7.81391C7.94073 8.35049 7.37301 9.02689 6.9414 9.81997C6.4873 8.42066 5.4426 7.39409 4.10335 7.18416C2.12756 6.99779 0.288379 8.65364 0.0386433 11.1031C-0.256414 13.5054 1.17406 15.6277 3.10398 15.8847C4.39838 16.0711 5.57916 15.4413 6.32831 14.2985C6.80529 17.2605 9.41655 19.5 12.3 19.5C13.9577 19.5 15.4336 18.8237 16.5461 17.6804C17.9312 17.004 19.7704 16.7475 20.361 14.8351C21.1102 14.8116 21.7233 14.1582 21.9047 13.5986C22.2003 12.5024 21.7686 11.7329 21.1556 11.4528Z",
    fill: "#0D283A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMickyFace);
export default __webpack_public_path__ + "static/media/micky-face.56869bd756abd12349ae56df8918e6b1.svg";
export { ForwardRef as ReactComponent };